export const API_INCOME_GET_BROKREAGE_LIST_SUCCESS =
    "API_INCOME_GET_BROKREAGE_LIST_SUCCESS";
export const API_INCOME_GET_BROKREAGE_LIST_FAIL =
    "API_INCOME_GET_BROKREAGE_LIST_FAIL";
export const GET_INCOME_GET_BROKREAGE_LIST = "GET_INCOME_GET_BROKREAGE_LIST";
export const CLIENT_WISE_INCOME = 'CLIENT_WISE_INCOME';
